<template>
  <detail
    :on-manager="onManager"
    :data="data"
    :isEditDesc="true"
    :isEditName="false"
    :base-info="baseInfo"
    :hiddenKeys="hiddenKeys" />
</template>

<script>
import {
  getSubscriptionProjectTableColumn,
  getSubscriptionBillingTypeTableColumn,
  getFrequencyTableColumn,
  getSubjectTableColumn,
  getEmailsTableColumn,
  getRoleTableColumn,
  getBillScopeTableColumn,
  getNotifyTypeTableColumn,
  getPrepaidAmortizingColumn,
  getProjectSharingColumn,
} from '../utils/columns'

export default {
  name: 'SubscriptionListDetail',
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      hiddenKeys: ['status', 'project_domain', 'tenant'],
      baseInfo: [
        getSubscriptionProjectTableColumn(),
        getSubscriptionBillingTypeTableColumn(),
        getBillScopeTableColumn({ vm: this }),
        getFrequencyTableColumn(),
        getNotifyTypeTableColumn(),
        getSubjectTableColumn(),
        getEmailsTableColumn({ scope: this.$store.getters.scope }),
        getRoleTableColumn({ scope: this.$store.getters.scope }),
        getPrepaidAmortizingColumn(),
        getProjectSharingColumn(),
      ],
    }
  },
}
</script>
